<template>
    <div v-if="pendentes">
        <div class="card" v-if="pendentes.trocas && pendentes.trocas.length">
            <div class="card-header d-flex justify-content-between">
                <div>
                    <a href="#" @click.prevent="exibir_solicitadas = !exibir_solicitadas" class="card-link">
                        Trocas Solicitadas
                    </a>
                </div>
                <div>
                    <span class="badge badge-secondary">{{ pendentes.trocas.length }}</span>
                </div>
            </div>
            <ul class="list-group" v-show="exibir_solicitadas">
                <li class="list-group-item" v-for="(troca, itx) in pendentes.trocas" :key="itx">
                    <div class="row">
                        <div class="col col-12 col-md-5">
                            <div class="small">Trocar:</div>
                            <div class="h5 mb-0">
                                {{ $util.getFormatDate(troca.escala_troca.dt_escala) }}
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                {{ $util.getFormatDate(troca.escala_troca.dt_escala, 'dddd') }}
                            </div>
                        </div>
                        <div class="col col-12 col-md-5">
                            <div class="small">Por:</div>
                            <div class="h5 mb-0">
                                {{ $util.getFormatDate(troca.escala.dt_escala) }}
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                {{ $util.getFormatDate(troca.escala.dt_escala, 'dddd') }}
                            </div>
                        </div>
                        <div class="col col-12 col-md-2 text-right">
                            <button type="button" class="btn btn-success mr-1" @click="efetivar_troca(troca)">
                                <i class="fa fa-check" aria-hidden="true"></i>
                            </button>
                            <button type="button" class="btn btn-danger" @click="cancelar_movimentacao(troca)">
                                <i class="fa fa-times" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>

                    <hr>

                    <div class="row">
                        <div class="col col-12">
                            <div>
                                {{ troca.escala.agenda.local }}
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                {{ troca.escala.agenda.search }}
                            </div>
                            <div class="lead">{{ troca.escala.usuario.search }}</div>
                            <div class="small text-muted blockquote-footer" v-if="troca.st_observacao">
                                {{ troca.st_observacao }}
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <div class="card" v-if="pendentes.aguardando && pendentes.aguardando.length">
            <div class="card-header d-flex justify-content-between">
                <div>
                    <a href="#" @click.prevent="exibir_aguardando = !exibir_aguardando" class="card-link">
                        Trocas Aguardando
                    </a>
                </div>
                <div>
                    <span class="badge badge-secondary">{{ pendentes.aguardando.length }}</span>
                </div>
            </div>
            <ul class="list-group" v-show="exibir_aguardando">
                <li class="list-group-item d-flex justify-content-between" v-for="(troca, itx) in pendentes.aguardando" :key="itx">
                    <div>
                        <div class="h5">
                            <div class="small mt-2">Trocar:</div>
                            {{ $util.getFormatDate(troca.escala.dt_escala) }}
                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                            {{ $util.getFormatDate(troca.escala.dt_escala, 'dddd') }}

                            <div class="small mt-2">Por:</div>
                            {{ $util.getFormatDate(troca.escala_troca.dt_escala) }}
                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                            {{ $util.getFormatDate(troca.escala_troca.dt_escala, 'dddd') }}
                        </div>

                        <hr>

                        <div>
                            {{ troca.escala.agenda.local }}
                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                            {{ troca.escala.agenda.search }}
                        </div>
                        <div class="lead">{{ troca.escala_troca.usuario.search }}</div>
                    </div>
                    <div>
                        <button type="button" class="btn btn-danger" @click="cancelar_movimentacao(troca)">
                            <i class="fa fa-times" aria-hidden="true"></i>
                        </button>
                    </div>
                </li>
            </ul>
        </div>

        <!-- Vendas -->
        <div class="card" v-if="pendentes.vendas && pendentes.vendas.length">
            <div class="card-header d-flex justify-content-between">
                <div>
                    <a href="#" @click.prevent="exibir_vendas = !exibir_vendas" class="card-link">
                        Vendas
                    </a>
                </div>
                <div>
                    <span class="badge badge-secondary">{{ pendentes.vendas.length }}</span>
                </div>
            </div>
            <ul class="list-group" v-show="exibir_vendas">
                <li class="list-group-item" v-for="(venda, itx) in pendentes.vendas" :key="itx">
                    <div class="row">
                        <div class="col col-12 col-md-10">
                            <div class="small">{{ venda.id_usuario != $store.state.user.id_usuario ? 'Adquirir:' : 'Vender:' }}</div>
                            <div class="h5 mb-0">
                                {{ $util.getFormatDate(venda.escala.dt_escala) }}
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                {{ $util.getFormatDate(venda.escala.dt_escala, 'dddd') }}
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                {{ venda.escala.agenda.hr_inicio }} - {{ venda.escala.agenda.hr_termino }}
                                <i class="fas fa-stopwatch ml-3"></i>
                                {{ venda.escala.agenda.duracao }}h
                            </div>
                        </div>
                        <div class="col col-12 col-md-2 text-right">
                            <button type="button" class="btn btn-success mr-1" @click="efetivar_venda(venda)" v-if="venda.id_usuario != $store.state.user.id_usuario">
                                <i class="fa fa-check" aria-hidden="true"></i>
                            </button>
                            <button type="button" class="btn btn-danger" @click="cancelar_movimentacao(venda)" v-if="venda.id_usuario_venda || venda.id_usuario == $store.state.user.id_usuario">
                                <i class="fa fa-times" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>

                    <hr>

                    <div class="row">
                        <div class="col col-12">
                            <div>
                                {{ venda.escala.agenda.local }}
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                {{ venda.escala.agenda.search }}
                            </div>
                            <div class="lead">{{ venda.escala.usuario.search }}</div>
                            <div class="small text-muted blockquote-footer" v-if="venda.st_observacao">
                                {{ venda.st_observacao }}
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>


        <!-- Motivo Cancalemento -->
        <div class="modal fade" id="cancelarMovModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="edicao">
                    <div class="modal-header">
                        <h5 class="modal-title">Cancelamento</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-input
                            label="Motivo"
                            type="textarea"
                            rows="5"
                            required
                            :validate="validate"
                            v-model="motivo" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit color="danger" @click="salvar_cancelamento()">Cancelar Movimentação</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() { 
        return { 
            pendentes: null, 
            exibir_solicitadas: false, 
            exibir_aguardando: false, 
            exibir_vendas: false, 
            validate: false, 
            edicao: null, 
            motivo: "", 
        }
    },

    components: { 
        AzInput,
        AzSubmit, 
    },
    
    methods: { 
        cancelar_movimentacao(mov) { 
            this.edicao = _.cloneDeep(mov);
            this.validate = false;
            this.motivo = "";

            $('#cancelarMovModal').modal('show');
        },

        salvar_cancelamento () {

            this.$util.atualizar(this, { 
                service: 'plantao_escalas',
                func: 'cancelar_movimentacao',
                dados: { 
                    id_plantao_movimentacao: this.edicao.id_plantao_movimentacao,
                    motivo: this.motivo,
                },
                modal: 'cancelarMovModal',
                toast: true, 
                callback: () => { 
                    this.$emit('refresh');
                }, 
            });

        },

        efetivar_troca (mov) { 

            if ( !confirm("Confirma efetivar a troca?") )
                return;

            this.$util.atualizar(this, { 
                service: 'plantao_escalas',
                func: 'efetivar_troca',
                dados: { 
                    id_plantao_movimentacao: mov.id_plantao_movimentacao,
                },
                toast: true, 
                callback: () => { 
                    this.$emit('refresh');
                }, 
            });

        },

        efetivar_venda (mov) { 

            if ( !confirm("Confirma efetivar a compra?") )
                return;

            this.$util.atualizar(this, { 
                service: 'plantao_escalas',
                func: 'efetivar_venda',
                dados: { 
                    id_plantao_movimentacao: mov.id_plantao_movimentacao,
                },
                toast: true, 
                callback: () => { 
                    this.$emit('refresh');
                }, 
            });

        },

        load() { 

            this.$util.loadItem(this, { 
                service: 'plantao_escalas',
                func: 'movimentacoes_pendentes',
            })
            .then(res => { 
                this.pendentes = res;
            });

        }
    },

    mounted() { 
        // this.load();
    }
}
</script>